import { mockConferences } from 'src/data/mockConferences'
import { HttpService } from '..'

export class ConferencesService extends HttpService {
  constructor() {
    super()
    this.path = '/conferences'
  }

  getConferences() {
    return Promise.resolve({
      data: mockConferences,
      error: null
    })
  }

  getConferenceBySlug(slug) {
    const conference = mockConferences.find(conf => conf.slug === slug)
    return Promise.resolve({
      data: conference || null,
      error: null
    })
  }

  searchConferences({ q, type, size, t }) {
    let filteredConferences = [...mockConferences]

    if (q) {
      const query = q.toLowerCase()
      filteredConferences = filteredConferences.filter(conf => 
        conf.title.toLowerCase().includes(query) || 
        conf.description.toLowerCase().includes(query)
      )
    }

    if (type !== null && type !== undefined) {
      const typeMap = {
        'IN_PERSON': 'IN_PERSON',
        'ONLINE': 'ONLINE',
        'HYBRID': 'HYBRID'
      }
      filteredConferences = filteredConferences.filter(conf => 
        conf.event_type === typeMap[type] || conf.event_type === type
      )
    }

    if (t === 'past') {
      filteredConferences = filteredConferences.filter(conf => 
        new Date(conf.end_date) < new Date()
      )
    } else {
      filteredConferences = filteredConferences.filter(conf => 
        new Date(conf.end_date) >= new Date()
      )
    }

    return Promise.resolve({
      data: filteredConferences,
      error: null
    })
  }

  switchFavorite(member_id, slug) {
    const conference = mockConferences.find(conf => conf.slug === slug)
    if (conference) {
      conference.is_favorite = !conference.is_favorite
    }
    return Promise.resolve({
      data: { success: true },
      error: null
    })
  }
}
